import Vue from 'vue';
import {Component, Prop } from 'vue-property-decorator';
@Component({
    name: "UserRightConfirm",
    template: `<div class="user-right-confirm-wrapper"><div class="saving-leave-page-confirm">
  <div class="title">{{ messages.title}} </div>
  <div class="el-text-center">
   <el-radio v-model="right" label="normal"> {{ messages.op1 }}</el-radio>
   <el-radio v-model="right" label="master"> {{ messages.op2 }}</el-radio>
  </div>
  <div class="text-center" >
        <el-button size="mini" @click="ok()" type="primary" > Ok </el-button>
  </div>
</div></div>`
})
class UserRightConfirm extends Vue {
    @Prop({ default: () => { } }) messages;
    right: string = 'normal';

    ok() { this.$emit('confirm', {
        isLoginFullRight: this.right === 'master'
    })}
}

export default UserRightConfirm;